import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {Home} from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Navbar from "./components/Navbar/Navbar";
import { Grid2,Paper} from "@mui/material";
import './App.css'
import { Footer } from "./pages/Footer/Footer";
import { NewsLetter } from "./pages/Newsletter/NewsLetter";
import {Header} from "./components/Header/Header";
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Products from "./pages/Products/Products";
import {ProductPage} from "./pages/ProductPage/ProductPage"

const App = () => {
  return (
    <>
    <Grid2 className='gbg-container'>
      <Grid2 component={Paper} elevati0n={8} className="scrollertop"  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} sx={{width:"max-content",color:"#fff",padding:"10px",backgroundColor:"green",border:"2px solid green", position:"fixed",bottom:"10%",right:"1%",zIndex:"1000",borderRadius:"5px"}}>
        <KeyboardDoubleArrowUpIcon  />
      </Grid2>
    <Router>
        <Header/>
        <Navbar />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:category/:productName/:id" element={<ProductPage />} />
        </Routes>
        <Footer/>
    </Router>
    </ Grid2>
    </>
  );
};

export default App;